<template>
  <vue-modal :key="refreshModal" :ref="modalName" :name="modalName" :scrollable="true" :width="775" :height="'auto'" :minHeight="700" :maxHeight="800">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title suggestions-popup-header">{{ title }}</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        
        <div class="suggestions-data-container">
          <div class="col-12 form-inline pl-0 pb-2">
            <div class="col-3">
              <div class="d-flex justify-content-left flex-wrap leftLabel moat-name-header">Moat</div>
            </div>
            <div class="col-9">
              <div class="d-flex justify-content-left flex-wrap labelData moat-name-header">{{ moatName }}</div>
            </div>
          </div>
          <div class="col-12 form-inline pl-0 pb-2">
            <div class="col-3">
              <div class="d-flex justify-content-left flex-wrap leftLabel">Why Customer Buy</div>
            </div>
            <div class="col-9">
              <div class="d-flex justify-content-left flex-wrap labelData">{{ moatDescription?.description }}</div>
            </div>
          </div>
          <div class="col-12 form-inline pl-0 pb-2" v-if="moatFeatures">
            <div class="col-3">
              <div class="d-flex justify-content-left flex-wrap leftLabel">Moat Features</div>
            </div>
            <div class="col-9">
              <div class="d-flex justify-content-left flex-wrap labelData">{{ moatFeatures }}</div>
            </div>
          </div>
          <div class="col-12 pt-2">
            <table id="road-map-initiatives-table" :class="table.class" cellspacing="2" width="100%">
              <thead>
                <tr>
                  <th class="suggestions-header radio-button"></th>
                  <th class="suggestions-header">Initiative Ideas to Consider</th>
                  <th class="suggestions-header">Primary Emotion</th>
                  <th class="suggestions-header text-center" style="padding-right: 0 !important">Success Level</th>
                  <th class="suggestions-header text-center" style="padding-right: 0 !important">Sales % Increase</th>
                  <th class="suggestions-header text-center" style="padding-right: 0 !important">Cost % Reduction</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="artificial-intelligence-tools">
          Artificial-intelligence tools helped create the Initiative Ideas and metric ranges, <br/>based on this customer need and your industry
        </div>
        <div class="suggestions-popup-buttons float-right mr-2">
          <button v-show="displayInitiatives" type="button" class="btn btn-primary mr-4" @click="addInitiative" :disabled="!selectedInitiativeId">Add Initiative</button>
          <button type="button" class="btn btn-primary ml-2 float-right ml-2 mr-2" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import Vue from "vue";
import $, { type } from "jquery";
import AlertService from "../services/alert.service";
import ValueGroupMap from "../services/chart/value.group.map.service";
import ViewMixins from "../mixins/ViewMixins.vue";
import GlobalMixins from "../mixins/GlobalMixins";
import Swal from 'sweetalert2';

export default {
  name: "RoadMapInitiatives",
  mixins: [ViewMixins, GlobalMixins],
  components: {},
  methods: {
    addInitiative() {
      if (this.selectedInitiative) {
        //console.log("Adding initiative:", this.selectedInitiative);
        this.$emit('add-initiative', this.selectedInitiative, this.needName);
        this.closeModal();
      } else {
        AlertService.error("Please select an initiative to add.");
      }
    },
    closeModal() {
      if(this.$refs[this.modalName] != null) {
        this.$refs[this.modalName].visible = false;
      }
      this.refreshModal = !this.refreshModal;
    },
    async loadData() {
      this.selectedInitiativeId = "";
      this.destroyTable();
      this.drawTable();
    },
    drawTable() {
      this.table.data = this.moatInitiatives;
      $.extend(this.table.configuration, { columns: this.table.columns });
      $.extend(this.table.configuration, {
        data: $.map(this.table.data, function (d) {
          return [d];
        }),
      });
      setTimeout(() => {
        this.table.dataTable = $("#" + this.table.id).DataTable(this.table.configuration);
        $("#" + this.table.id).show();

        // Re-check previously selected radio button
        if (this.selectedInitiativeId) {
          $(`#${this.table.id} input[type=radio][value="${this.selectedInitiativeId}"]`).prop("checked", true);
        }
        if(this.isInsiderUser) {
          this.$nextTick(() => {
            // Listen to scroll events on the scroll body
            let alertShown = false;
            const scrollContainer = $("#" + this.table.id + "_wrapper .dt-scroll-body");
            scrollContainer.on("scroll", function () {
              $(this).scrollTop(0);
              if (!alertShown) {
                alertShown = true;
                $(this).scrollTop(0);
                Swal.fire({
                  title: '',
                  html: '<h5 class="text-center">You need to activate your full subscription to see all Initiative Ideas.</h5>',
                  showCloseButton: false,
                  showCancelButton: false,
                  showConfirmButton: false,
                  footer: '',
                  allowOutsideClick: true,
                  didOpen: () => {
                    const htmlContainer = document.querySelector('.swal2-html-container');
                    if (htmlContainer) {
                      htmlContainer.classList.remove('swal2-html-container');  // Remove default class
                      htmlContainer.classList.add('no-extra-space');           // Add your custom class
                    }
                  }
                })
                
                // Reset flag after short delay (so it can show again later if needed)
                setTimeout(() => {
                  alertShown = false;
                }, 100); 
              }
            });
          });
        }

        $("#" + this.table.id)
          .off("change", ".select-radio")
          .on("change", ".select-radio", (e) => {
            this.selectedInitiativeId = $(e.target).val();
            const selectedRow = this.table.data.find(row => row.moatInitiativeId == this.selectedInitiativeId);
            this.selectedInitiative = selectedRow;
          });
          if (!this.displayInitiatives){
            $("#" + this.table.id + " input.suggestions-popup-radio").hide();
          }
      }, 0);
    },
    destroyTable() {
      $("#" + this.table.id).hide();
      if (typeof this.table.dataTable != "undefined") {
        this.table.dataTable.destroy();
      }
    },
  },
  props: {
    modalName: {
      type: String,
      default: "road-map-initiatives"
    },
    displayInitiatives: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      refreshModal: true,
      title: "Road Map Initiatives",
      needName: "",
      moatDescription: {
        description: "",
        attributes: "{}"
      },
      moatInitiatives: [],
      moatName: "",
      selectedInitiative: "",
      selectedInitiativeId: "",
      initiatives: [],
      features: "",
      element: Object,
      table: {
        id: "road-map-initiatives-table",
        class: "table display wrap row-border table-hover p-0",
        configuration: {
          dom: '<"top"if>rtp<"bottom"><"clear">',
          searching: false,
          scrollY: "200px",
          scrollCollapse: true,
          paging: false,
          //pageLength: 10,
          select: true,
          processing: false,
          responsive: true,
          destroy: true,
          info: false,
          keys: true,
          sort: false,
          bSortable: false,
          bSort: false,
          buttons: [],
          ordering: false, // disable all table sorting
          columnDefs: [
            {
              targets: "_all",
              orderable: false  // Ensures each column is non-sortable
            }
          ],
        },
        columns: ValueGroupMap.getRoadMapInitiativesTableColumnData(),
      },
    };
  },
  computed: {
    moatFeatures() {
      if (typeof this.moatDescription != "undefined" && this.moatDescription != null && this.moatDescription.attributes) {
        let moatAttributes = JSON.parse(this.moatDescription.attributes);
        return moatAttributes?.features || "";
      }
      return "";
    },
    initiativeEmotion() {
      if (typeof this.moatDescription != "undefined" && this.moatDescription != null && this.moatDescription.features) {
        let moatAttributes = JSON.parse(this.moatDescription.features);
        return moatAttributes?.features || "";
      }
      return "";
    }
  },
  mounted() {}
};
</script>
